export default __webpack_public_path__ + "static/media/partners1.c08fac1c.png";